import React, { memo } from 'react';
import classNames from 'classnames';
import { Cross } from '@saleshandy/icons';
import { DialerCall } from '../../../svg/dialer-call';
import { accessibleOnClick } from '../../../utils';
import { PhoneNumbersPickerSheetProps } from '../types';

const PhoneNumberPickerSheet: React.FC<PhoneNumbersPickerSheetProps> = ({
  isOpen,
  onClose,
  contactName,
  phoneNumbers,
  onSelectNumber,
  inline = false,
  prospectName = '',
}) => (
  <>
    {/* Backdrop */}
    <div
      className={classNames('phone-numbers-bottom-sheet-backdrop', {
        'phone-numbers-bottom-sheet-backdrop--open': isOpen,
        'phone-numbers-bottom-sheet-backdrop--inline': inline,
      })}
      aria-hidden={!isOpen}
      {...accessibleOnClick(onClose)}
    />

    {/* Sheet */}
    <div
      className={classNames('phone-numbers-bottom-sheet', {
        'phone-numbers-bottom-sheet--open': isOpen,
        'phone-numbers-bottom-sheet--inline': inline,
      })}
      aria-modal="true"
      role="dialog"
      aria-label={`Phone numbers for ${contactName}`}
    >
      {/* Handle bar */}
      <div className="phone-numbers-bottom-sheet-handle" aria-label="Close">
        <div className="phone-numbers-bottom-sheet-handle-bar">
          <span className="phone-number-selected-prospect-name">
            {prospectName?.trim() || ''}
          </span>
          <div
            className="phone-numbers-bottom-sheet-close-icon"
            {...accessibleOnClick(onClose)}
          >
            <Cross width={16} height={16} />
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="phone-numbers-bottom-sheet-content">
        <div className="phone-numbers-bottom-sheet-list">
          {phoneNumbers
            ?.map((entry, index) =>
              typeof entry === 'string'
                ? {
                    number: entry,
                    label: `Number ${index + 1}`,
                    isPrimary: false,
                    // phoneNumber: entry
                  }
                : entry,
            )
            ?.sort((a, b) => Number(b?.isPrimary) - Number(a?.isPrimary))
            ?.map((item, index) => {
              const {
                number: displayNumber,
                label,
                isPrimary,
                phoneNumber,
              } = item;

              return (
                <div
                  key={`${displayNumber}-${index + 1}`}
                  className="phone-numbers-bottom-sheet-item"
                >
                  <div className="phone-numbers-bottom-sheet-item-info">
                    <span className="phone-numbers-bottom-sheet-item-label">
                      {label}
                    </span>
                    <span className="phone-numbers-bottom-sheet-item-number">
                      {displayNumber}
                      {isPrimary && (
                        <span className="phone-numbers-bottom-sheet-item-primary">
                          Primary
                        </span>
                      )}
                    </span>
                  </div>
                  <div className="phone-numbers-bottom-sheet-item-actions">
                    <button
                      type="button"
                      className="phone-numbers-bottom-sheet-item-call"
                      onClick={(e) => {
                        e.stopPropagation();
                        onSelectNumber(phoneNumber || displayNumber);
                        onClose();
                      }}
                      aria-label={`Call ${displayNumber}`}
                    >
                      <DialerCall
                        width={16}
                        height={16}
                        className="phone-numbers-bottom-sheet-call-icon"
                      />
                    </button>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  </>
);

export default memo(PhoneNumberPickerSheet);
